module.exports = __webpack_public_path__ + "img/icon-chat.6c3266fc.svg";